





























































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DxSelectBox } from 'devextreme-vue';

import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    AuthServiceContract,
    SignInType,
    DialogButton,
    WindowsServiceContract
} from '@/core/contracts';
import { Role } from '@/dto';
import { ContextsState } from '@/store';
import { copyToClipboard } from '@/core/helpers';
import { getBaseUrl } from '@/core/helpers/utils';

interface IUserInvitation {
    code: string;
    contextId: number;
    date: string;
    id: number;
    role: Role;
}

@Component({
    components: {
        DxSelectBox
    }
})
export default class ContextSettingsInvitesComponent extends Vue {
    public inLoading: boolean = false;
    public invites: IUserInvitation[] = [];
    public loadedRoles: Role[] = [];

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;

    public async mounted() {
        await this.loadRoles();
        await this.loadInvites();
    }

    public copyInvitationUrl(code: string): void {
        const text = getBaseUrl() + 'invitations/' + code;
        copyToClipboard(text);
    }

    public async createNewInviteFor(forRole: Role, $event: any): Promise<void> {
        const currentContextId = ContextsState.currentContextId;
        const createdInvite = await this._fetchService!.post<IUserInvitation>(
            '/contexts/' + currentContextId + '/invite?roleId=' + forRole.id
        );
        this.invites.push(createdInvite);
        $event.component.reset();
    }

    public async deleteInvite(id: number): Promise<void> {
        this.inLoading = true;
        try {
            const currentContextId = ContextsState.currentContextId;
            await this._fetchService!.delete(
                '/contexts/' + currentContextId + '/invitations',
                id
            );
            this.invites = this.invites.filter(f => f.id !== id);
        } finally {
            this.inLoading = false;
        }
    }

    private async loadInvites(): Promise<void> {
        this.inLoading = true;
        try {
            const currentContextId = ContextsState.currentContextId;
            const loadedInvites = await this._fetchService!.get<
                Array<IUserInvitation>
            >('/contexts/' + currentContextId + '/invitations');
            this.invites = loadedInvites;
        } finally {
            this.inLoading = false;
        }
    }

    private async loadRoles(): Promise<void> {
        if (this.loadedRoles.length === 0) {
            const currentContextId = ContextsState.currentContextId;
            const roles = await this._fetchService!.get<Array<Role>>(
                '/contexts/' + currentContextId + '/roles'
            );
            this.loadedRoles = roles;
        }
    }
}
